module.exports = __webpack_public_path__ + "static/media/certificate-path-completed.5abcfc4f.svg";